module.exports = __webpack_public_path__ + "assets/img/img38.27397e04.png";